<template>
	<v-card
		variant="flat"
	>
		<v-card-title>
			<translate>
				Check personal data
			</translate>
		</v-card-title>
		<v-card-text
			class="text-grey-darken-2"
		>
			<v-row>
				<v-col>
					<translate>Below you can find information on the phone that you insured. Please check this data for inconsistencies. If there is anything wrong with the data, you should change it by going to</translate>
					<a
						class="ml-1"
						:href="editProfileRoute"
					>
						<translate>edit information</translate>
					</a>
					<translate>, or by</translate>
					<a
						class="ml-1"
						:href="contactRoute"
					>
						<translate>contacting</translate>
					</a>
					<span class="ml-1">
						<translate>us</translate>
					</span>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-divider />
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<translate>
						Details of insured device
					</translate>
					<v-list
						lines="two"
					>
						<v-list-item
							class="pl-0"
							:title="$gettext('Product')"
							:subtitle="row.phoneModel"
						/>
						<v-list-item
							v-if="row.phoneImei"
							class="pl-0"
							title="IMEI"
							:subtitle="row.phoneImei"
						/>
						<v-list-item
							class="pl-0"
							title="EAN"
							:subtitle="row.phoneEAN"
						/>
						<v-list-item
							v-if="row.phoneSerialNumber"
							class="pl-0"
							:title="$gettext('Serial Number')"
							:subtitle="row.phoneSerialNumber"
						/>
						<v-list-item
							class="pl-0"
							:title="$gettext('Price paid')"
							:subtitle="row.phonePurchasePrice"
						/>
						<v-list-item
							class="pl-0"
							:title="$gettext('Date of sale')"
							:subtitle="row.phonePurchaseDate"
						/>
					</v-list>
				</v-col>
				<v-divider vertical />
				<v-col>
					<translate>
						Details of policyholder and policy
					</translate>
					<v-list
						lines="two"
					>
						<v-list-item
							class="pl-0"
							:title="$gettext('Policy number')"
							:subtitle="row.identifier"
						/>
						<v-list-item
							class="pl-0"
							:title="$gettext('Start date')"
							:subtitle="row.startDate"
						/>
						<v-list-item
							class="pl-0"
							:title="$gettext('Name policyholder')"
							:subtitle="user.fullName"
						/>
						<v-list-item
							class="pl-0"
							:title="$gettext('Email address')"
							:subtitle="user.email"
						/>
					</v-list>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-divider />
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<h2>
						<translate>How can we contact you?</translate>
					</h2>
					<v-row class="mt-4">
						<v-col
							cols="12"
						>
							<h3>
								<translate>Phone number</translate>
							</h3>
							<p>
								<translate>
									If we have questions about your claim, what would be the best
									way to contact you?
								</translate>
							</p>
							<v-radio-group
								class="mt-2"
								:model-value="modelValue.selectedTelephoneNumber"
								:error-messages="errors.selectedTelephoneNumber"
								@update:model-value="updated => update('selectedTelephoneNumber', updated)"
							>
								<v-radio
									v-for="telephoneNumber in telephoneNumbers"
									:key="telephoneNumber.id"
									color="primary"
									:value="telephoneNumber.id"
									:label="telephoneNumber.number"
								/>
								<v-radio
									color="primary"
									class="listenable_radio"
									:value="-1"
									:label="$gettext('On a different phone number, namely:')"
								/>
							</v-radio-group>
						</v-col>
					</v-row>
					<v-row
						v-if="modelValue.selectedTelephoneNumber === -1"
					>
						<v-col
							cols="12"
						>
							<v-text-field
								class="listenable_text"
								:label="$gettext('Phone number')"
								:error-messages="errors.alternativeTelephoneNumber"
								placeholder="+31 6 000 000 00"
								variant="outlined"
								:model-value="modelValue.alternativeTelephoneNumber"
								@update:model-value="updated => update('alternativeTelephoneNumber', updated)"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col
							cols="12"
						>
							<h3>
								<translate>Delivery Address</translate>
							</h3>
							<p>
								<translate>We will send your repaired or replaced phone to:</translate>
							</p>

							<v-radio-group
								class="mt-2"
								:model-value="modelValue.selectedAddress"
								:error-messages="errors.selectedAddress"
								@update:model-value="updated => update('selectedAddress', updated)"
							>
								<v-radio
									v-for="address in addresses"
									:key="address.id"
									color="primary"
									:value="address.id"
									:label="`${address.street} ${address.postalCode} ${address.city}`"
								/>
								<v-radio
									color="primary"
									value="-1"
									:label="$gettext('I would like to receive my phone at a different address, namely:')"
								/>
							</v-radio-group>
						</v-col>
					</v-row>
					<v-row
						v-if="modelValue.selectedAddress === '-1'"
					>
						<v-col>
							<address-fields
								enable-autofill
								country-name="Netherlands"
								:model-value="modelValue.alternativeAddress"
								@update:model-value="updated => update('alternativeAddress', updated)"
							/>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	set, cloneDeep,
} from 'lodash';
import AddressFields from '../organisms/AddressFields.vue';
export default {
	name: 'ClaimFormPersonalInfo',
	components: {
		AddressFields
	},
	props: {
		row: {
			type: Object,
			required: true
		},
		user: {
			type: Object,
			required: true
		},
		telephoneNumbers: {
			type: Array,
			required: true
		},
		addresses: {
			type: Array,
			required: true
		},
		modelValue: {
			type: Object,
			required: true,
		},
		errors: {
			type: Object,
			required: true,
		}
	},

	emits: ['update:model-value',],

	data () {
		return {
			editProfileRoute: '/dashboard/profile/edit',
			contactRoute: '/klantenservice/contact',
		};
	},

	methods: {
		/**
		 * @param {string} key
		 * @param {string} value
		 */
		update (key, value) {
			const updated = cloneDeep(this.modelValue);

			set(updated, key, value);

			this.$emit('update:model-value', updated);
		}
	}
};
</script>
<style scoped>
hr {
	margin-top: 0px;
	margin-bottom: 0px;
	border-color: rgb(97, 97, 97);
}

h2 {
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
}

h3 {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
}
</style>

